type GetStartOfDate = (date: Date) => Date;
type GetEndOfDate = (date: Date) => Date;
type GetDateInTimezone = (date?: Date | string) => Date;

/**
 * Computes the account-timezone start/end-of-day UTC instants for a browser-local calendar day
 * (as produced directly by the DatePicker widget). Mirrors the Rides "Jump To" pattern.
 */
export const getRecordingsDateRange = (
  date: Date,
  getStartOfDate: GetStartOfDate,
  getEndOfDate: GetEndOfDate
): { startDate: string; endDate: string } => ({
  startDate: getStartOfDate(date).toISOString(),
  endDate: getEndOfDate(date).toISOString(),
});

/**
 * Rehydrates a stored UTC instant (e.g. the `fromDate` URL param, already account-timezone
 * adjusted) back into the same start/end-of-day range. Converts the instant into the account's
 * calendar day first, then re-derives the range the same way a fresh selection would — avoids
 * double-adjusting an already-adjusted instant.
 */
export const rehydrateRecordingsDateRange = (
  isoString: string,
  getDateInTimezone: GetDateInTimezone,
  getStartOfDate: GetStartOfDate,
  getEndOfDate: GetEndOfDate
): { startDate: string; endDate: string } => {
  const zoned = getDateInTimezone(isoString);
  const localCalendarDay = new Date(zoned.getFullYear(), zoned.getMonth(), zoned.getDate());

  return getRecordingsDateRange(localCalendarDay, getStartOfDate, getEndOfDate);
};
